// Design tokens for the restaurant Payments page. Stripe's own visual language,
// so our cards and Stripe's embedded components read as one surface.

export const color = {
  page: '#F6F9FC',
  surface: '#FFFFFF',
  border: '#E3E8EE',
  divider: '#EBEEF1',
  subtle: '#F6F8FA',

  accent: '#635BFF',
  accentHover: '#5851DF',
  accentSoft: 'rgba(99, 91, 255, 0.08)',
  accentRing: 'rgba(99, 91, 255, 0.35)',

  success: '#00A868',
  successSoft: '#E6F6EF',
  warning: '#F5A623',
  warningText: '#9A5B00',
  warningSoft: '#FEF4E4',
  error: '#DF1B41',
  errorSoft: '#FDECEF',

  text: '#1A1F36',
  muted: '#697386',
  faint: '#A3ACB9',
}

export const radius = {
  card: '12px',
  control: '8px',
  pill: '999px',
}

export const shadow = {
  card: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  raised: '0 4px 12px rgba(26,31,54,0.08), 0 1px 3px rgba(0,0,0,0.05)',
}

export const font = "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

export const type = {
  pageTitle: { fontSize: { xs: 24, md: 28 }, fontWeight: 600, color: color.text, letterSpacing: '-0.01em' },
  sectionTitle: { fontSize: { xs: 17, md: 19 }, fontWeight: 600, color: color.text },
  label: { fontSize: 13, fontWeight: 500, color: color.muted },
  figure: { fontSize: { xs: 30, md: 36 }, fontWeight: 600, color: color.text, letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums' },
  body: { fontSize: 14, color: color.text },
  small: { fontSize: 13, color: color.muted },
}

// Keyboard focus, never the mouse click: a ring in the accent colour.
export const focusRing = {
  '&:focus-visible': { outline: `2px solid ${color.accentRing}`, outlineOffset: '2px' },
}

// Passed to Stripe's embedded components so they carry the same tokens.
export const connectAppearance = {
  overlays: 'dialog',
  variables: {
    fontFamily: font,
    fontSizeBase: '14px',
    colorPrimary: color.accent,
    colorBackground: color.surface,
    colorText: color.text,
    colorSecondaryText: color.muted,
    colorBorder: color.border,
    colorDanger: color.error,
    borderRadius: radius.control,
  },
}

export const connectFonts = [
  { cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap' },
]

export const usd = (v) => (v == null ? '—' : `$${Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`)

// 'YYYY-MM-DD' strings are calendar days; parse them as UTC so the day never
// shifts with the viewer's time zone.
export const dayLabel = (value, opts = { month: 'short', day: 'numeric' }) => {
  if (!value) return '—'
  const d = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00Z`) : new Date(value)
  const timeZone = /^\d{4}-\d{2}-\d{2}$/.test(value) ? 'UTC' : undefined
  return d.toLocaleDateString('en-US', { ...opts, timeZone })
}
